import React, { useContext, useEffect, useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import rest from "../../rest";
import { useSelector } from "react-redux";
// import debounce from 'lodash.debounce'
// ICON
import useRedirectAndReload from "../../components/general/redirectReload";
import ActivityCard from "./ActivityCard";
import ActivitySearch from "./ActivityShearch";
import ButtonStyled from "../../components/general/ButtonStyled";
import { useStylesGlobal } from "../GlobalStyle.css";
import { useStyleActivity } from "./Activity.css";
import AppContext from "../../components/appContext";
import { useTheme, useMediaQuery } from "@material-ui/core";
import ActivityModal from "./ActivityModal";



export const Activity = () => {
    const theme = useTheme();
    const manifParams = useSelector((state) => state.manif);
    const currentUser = useSelector((state) => state.user);
    const classesAccueil = useStyleActivity();
    const classesGlobal = useStylesGlobal();

    const [recherche, setRecherche] = useState("");
    const [selectDate, setSelectDate] = useState([]);
    const [hasRecherche, setHasRecherche] = useState(false);
    // Activites
    const [activites, setActivites] = useState([]);
    const [idSousActivites, setIdSousActivites] = useState(0);
    const [idActivites, setIdActivites] = useState(0);
    const [dateActivites, setDateActivites] = useState([]);
    const [idTrancheHoraire, setIdTrancheHoraire] = useState(0);
    const [dateTranche, setDateTranche] = useState("");
    const [horaireTranche, setHoraireTranche] = useState("");

    // Critere
    const [critere, setCritere] = useState([]);
    const [selectcritere, setSelectcritere] = useState([]);
    // Dialog
    const [open, setOpen] = useState(false);
    const [description, setDescription] = useState("");
    const [descriptionLongue, setDescriptionLongue] = useState("");
    const [nom, setNom] = useState("");
    // Dialog Plus Infos
    const [infos, setInfos] = useState([]);
    // Dialog Choisir
    const [restrict, setRestrict] = useState(false);
    const [showChoisir, setShowChoisir] = useState(false);
    const [showInfosPlus, setShowInfosPlus] = useState(false);
    const [showGererGrp, setShowGererGrp] = useState(false);

    const [reload, setReload] = useState(false);

    const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));
    // const querySmUp = useMediaQuery(theme.breakpoints.up("sm"));
    // const queryBetween = useMediaQuery(theme.breakpoints.between("sm", "md"));
    // const queryOnlyLg = useMediaQuery(theme.breakpoints.only("lg"));

    // useEffect(()=>{
    //     console.log('querysm =================>>>>>>>>>>>>>>>>>>>>>>>>> ', querysmDown, querySmUp, queryBetween, queryOnlyLg);

    // }, [querysmDown, querySmUp, queryBetween, queryOnlyLg]);



    const redirectAndReloadToConn = useRedirectAndReload({ url: "/connexion.html", typeLink: "fromActivity" });


    const myContext = useContext(AppContext);
    const openSidebar = myContext.openSidebar;

    // Requete pour les donnees concernant Plus Infos (document)
    const listPlusInfos = () => {
        let params = {
            vID: idSousActivites,
            vListe: "Lie",
        };
        try {
            rest.post("/documents/liste.json", params)
                .then((response) => {
                    setInfos(response.data);
                })
                .catch(() => {
                    console.error("/activites/recuperationDatesDispo.json Activity listPlusInfos");
                });
        } catch (error) {
            console.error("/activites/recuperationDatesDispo.json Activity listPlusInfos catch");
        }
    };

    useEffect(() => {
        listPlusInfos();
        // eslint-disable-next-line
    }, [idSousActivites]);


    const handleChange = (id) => {
        remiseAZero(['idActivites']);
        setIdActivites(id);
    };

    // Choisir Activité
    const ChoisirAct = (id, description, nom) => {
        setOpen(true);
        setShowChoisir(true);
        setShowInfosPlus(false);
        setShowGererGrp(false);
        setIdSousActivites(id);
        setDescription(description);
        setNom(nom);
    };

    // Les Inscrits
    const Inscrit = (id, description, nom) => {
        setOpen(true);
        setShowChoisir(false);
        setShowInfosPlus(false);
        setIdSousActivites(id);
        setDescription(description);
        setNom(nom);
    };

    const PlusInfos = (id, description, nom, descriptionLongue) => {
        setOpen(true);
        setShowChoisir(false);
        setShowInfosPlus(true);
        setIdSousActivites(id);
        setDescription(description);
        setDescriptionLongue(descriptionLongue);
        setNom(nom);
    };

    const handleClose = () => {
        setOpen(false);
        setShowGererGrp(false);
    };

    // Gerer Groupe
    const GererGRP = (id, description, nom) => {
        setShowChoisir(true);
        setShowInfosPlus(false);
        setShowGererGrp(false);
        setIdSousActivites(id);
        setDescription(description);
        setNom(nom);
    };

    const handleChangeRechercher = (event) => {
        setRecherche(event.target.value);
    }

    const handleChangeDate = (event) => {
        setSelectDate(event.target.value);
    };

    const handleChangeCheck = () => {
        setRestrict((prev) => !prev);
    };

    const handleChangeCritere = (event) => {
        setSelectcritere(event.target.value);
    };
    //  Suppression des recherches
    const remiseAZero = (exclud = []) => {
        if (!exclud.includes('recherche')) setRecherche("");
        if (!exclud.includes('selectDate')) setSelectDate([]);
        if (!exclud.includes('selectcritere')) setSelectcritere([]);
        if (!exclud.includes('idActivites')) setIdActivites(0);
    };

    // Requete pour avoir toutes les activites
    const listActivites = () => {

        let params = {
            vId: idActivites,
            vRechGenerale: recherche,
            vCaract: selectcritere.join(","),
            // vActiviteLibre: actLibre,
            vDateTest: selectDate.length > 0 ? JSON.stringify(selectDate) : "",
            vSpecification: "",
        };

        try {
            rest
                .post("/4DACTION/ACTIVITES_Liste", params)
                .then((response) => {
                    setActivites(
                        Array.isArray(response?.data?.activites) ? response.data.activites : []
                    );

                })
                .catch(() => {
                    console.error(
                        "/activites/recuperationDatesDispo.json Activity listActivites"
                    );
                });
        } catch (error) {
            console.error(
                "/activites/recuperationDatesDispo.json Activity listActivites catch"
            );
        }
    };

    useEffect(() => {
        listActivites();
        if (!selectDate.length && !recherche && !idActivites && !selectcritere.length)
            setHasRecherche(false);
        else setHasRecherche(true);
        // eslint-disable-next-line
    }, [selectDate, recherche, idActivites, selectcritere, reload]);

    return (
        (manifParams.manifParams.AffichagePageAccueil === "showActivities" || (currentUser.connected && currentUser.User.User_Administrator)) &&
            ((manifParams.manifInfos.StatutInscription === 1 && currentUser.connected) ||
                manifParams.manifInfos.StatutInscription === 2 ||
                currentUser.User.User_Administrator) ? (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} className={`${classesAccueil.searchWrapper} ${openSidebar ? classesAccueil.searchWrapperSmall : classesAccueil.searchWrapperBig}`}>
                        <ActivitySearch
                            classesAccueil={classesAccueil}
                            classesGlobal={classesGlobal}
                            recherche={recherche}
                            handleChangeRechercher={handleChangeRechercher}
                            selectDate={selectDate}
                            handleChangeDate={handleChangeDate}
                            dateActivites={dateActivites}
                            setDateActivites={setDateActivites}
                            selectcritere={selectcritere}
                            handleChangeCritere={handleChangeCritere}
                            critere={critere}
                            setCritere={setCritere}
                            remiseAZero={remiseAZero}
                            hasRecherche={hasRecherche}
                        />
                    </Grid>
                    <Grid container spacing={2} style={{
                        marginTop: `${querysmDown ? (hasRecherche ? '170px' : '130px') : (hasRecherche ? '100px' : '70px')}`,
                        width: openSidebar ? "calc(100vw - 247px)" : "calc(100vw - 30px)",
                    }}>
                        {activites && activites.length > 0 ? (
                            activites.map((activity, index) => {
                                if (!activity.active) return null;
                                return (
                                    <Grid item xs={6} md={4} key={index}>
                                        <ActivityCard
                                            act={activity}
                                            handleChange={handleChange}
                                            PlusInfos={PlusInfos}
                                            Inscrit={Inscrit}
                                            ChoisirAct={ChoisirAct}
                                        />
                                    </Grid>
                                );
                            })
                        ) : (<div>non activity</div>)}
                    </Grid>
                </Grid>
                {(open | showGererGrp) && (
                    <ActivityModal
                        open={open}
                        handleClose={handleClose}
                        nom={nom}
                        description={description}
                        myContext={myContext}
                        showInfosPlus={showInfosPlus}
                        showGererGrp={showGererGrp}
                        restrict={restrict}
                        handleChangeCheck={handleChangeCheck}
                        showChoisir={showChoisir}
                        idSousActivites={idSousActivites}
                        currentUser={currentUser}
                        manifParams={manifParams}
                        setShowGererGrp={setShowGererGrp}
                        setIdTrancheHoraire={setIdTrancheHoraire}
                        setDateTranche={setDateTranche}
                        setHoraireTranche={setHoraireTranche}
                        descriptionLongue={descriptionLongue}
                        infos={infos}
                        idTrancheHoraire={idTrancheHoraire}
                        dateTranche={dateTranche}
                        horaireTranche={horaireTranche}
                        ChoisirAct={ChoisirAct}
                        GererGRP={GererGRP}
                        setOpen={setOpen}
                        setReload={setReload}
                    />
                )}
            </>
        ) : (
            <Paper elevation={3} className={classesAccueil.paperClass}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: manifParams.manifInfos.StatutInscription === 0
                            ? manifParams.manifInfos.TextInscrFermees
                            : manifParams.manifInfos.StatutInscription === 1
                                ? manifParams.manifInfos.TextInscrAnciens
                                : manifParams.manifParams.pageAccueilText,
                    }}
                />


                {(manifParams.manifInfos.StatutInscription === 2 && !currentUser.connected) && (
                    <ButtonStyled
                        color="primary"
                        variant="contained"
                        onClick={(_) => redirectAndReloadToConn()}
                    >
                        {manifParams.manifInfos.Ref === "chi"
                            ? "Inscrivez-vous"
                            : "Inscris-toi"}
                    </ButtonStyled>
                )}
            </Paper>
        )
    );
};

export default Activity;
